import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Nav as NavBS } from 'react-bootstrap';
import Navbar from 'react-bootstrap/Navbar';
import NavLogoBlack from "../../assets/ourides/logo-ourides-noir.png";
import NavLogoTrans from "../../assets/ourides/logo-ourides-blanc.png";
import NavLoggedOut from './NavLoggedOut';
import NavLoggedIn from './NavLoggedIn';
import { Link } from 'react-router-dom';

class Navigation extends Component {
    state = {
        navBarTop: true
    };

    componentDidMount() {
        document.addEventListener('scroll', () => {
            const navBarTop = window.scrollY < 1;
            if (navBarTop !== this.state.navBarTop) {
                this.setState({ navBarTop })
            }
        });
    }

    scrollToTop () {
        document.documentElement.scrollTop = 0;
    }

    render() {
        return (
            <div className={this.state.navBarTop ? "navigation__mainTop" : "navigation__mainScroll"}>
                <Navbar collapseOnSelect expand="sm" fixed="top" className="navigation__navbar">
                    <Link to="/"><img src={this.state.navBarTop ? NavLogoTrans : NavLogoBlack} className="navigation__logo"/></Link>
                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                    <Navbar.Collapse id="responsive-navbar-nav">
                        <NavBS className="mr-auto">
                        </NavBS>
                        {!this.props.logged ? <NavLoggedOut auth={this.props.auth} /> : <NavLoggedIn auth={this.props.auth} />}
                    </Navbar.Collapse>
                </Navbar>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    logged: state.reducerUser.logged
});
export default connect(mapStateToProps)(Navigation);
